import React from 'react';
import PropTypes from 'prop-types';

import { ANNOTATION_TYPES, ICON_PATH } from '../../../constants';
import './AnnotationTypeSelector.css';


const ANNOTATION_TYPE_LABELS = Object.freeze({
  [ANNOTATION_TYPES.issue]: {
    label: 'Quality Issue',
    src: `${ICON_PATH}/quality-issue-icon.svg`,
  },
  [ANNOTATION_TYPES.suggestion]: {
    label: 'Leave a Suggestion',
    src: `${ICON_PATH}/suggestion-icon.svg`,
  },
});


const AnnotationTypeSelector = ({ onClose, onChange }) => (
  <div className="annotator-type-selector">
    <div className="close-btn-container">
      <button type="button" className="close-btn btn" onClick={onClose} />
    </div>
    <div className="annotator-types">
      {
        Object.keys(ANNOTATION_TYPE_LABELS).map(key => (
          <button
            type="button"
            key={key}
            className="annotation-type btn"
            onClick={() => onChange(key)}
          >
            <img
              src={ANNOTATION_TYPE_LABELS[key].src}
              alt={key}
              className="icon"
            />
            {ANNOTATION_TYPE_LABELS[key].label}
          </button>
        ))
      }
    </div>
  </div>
);


AnnotationTypeSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};


export default AnnotationTypeSelector;
